module.exports = __webpack_public_path__ + "assets/media/day12.a0a3f02d.mp3";